/// <amd-module name="Repos/Tfvc/Common/Utils/Comment" />
import { safeSubstring } from "VSS/Core/Util/String";
/**
 * Gets the short summary version of the given commit comment
 *
 * @param comment Commit comment
 */
export function getShortChangeComment(comment: string, maxLength = 80, includeEllipsisForNewLine = false): string {
    if (comment) {
        comment = comment.trim();
        const newLineIndex = comment.indexOf("\n");

        let newLineFound = false;
        let ellipsisAdded = false;
        if (newLineIndex > 0) {
            comment = safeSubstring(comment, 0, newLineIndex);
            newLineFound = true;
        }
        if (comment.length > maxLength) {
            comment = safeSubstring(comment, 0, maxLength - 3).trim() + "...";
            ellipsisAdded = true;
        }

        if (!ellipsisAdded && includeEllipsisForNewLine && newLineFound) {
            comment += "...";
        }
    }
    return comment;
}
